import React from "react";
import { Col, Row, Table } from "antd";

import { constructDisplayPrice } from "utils/general";

import InfoCard from "components/InfoCard/InfoCard";
import Title from "components/Title/Title";
import SectionContainer from "components/SectionContainer/SectionContainer";

import {
  SummaryValueText,
  DescriptionForLabel,
  ExtraInfoText,
  FinancialValueText,
  Label,
  SecureIcon,
} from "./Summary.styles";

import Locale from "react-intl-universal";

const constructPolicyCoveragesDataSource = (insurancesInfo) => [
  {
    label: Locale.get("summaryPolicyDetail.deathBenefit"),
    value: constructDisplayPrice(insurancesInfo.deathBenefit || 0, false),
  },
  {
    label: Locale.get("summaryPolicyDetail.tpdb"),
    value: constructDisplayPrice(insurancesInfo.tpdBenefit || 0, false),
  },
  {
    label: Locale.get("summaryPolicyDetail.oadb"),
    desc: Locale.get("summaryPolicyDetail.oadbDesc"),
    value: constructDisplayPrice(
      insurancesInfo.oldAgeDisabilityBenefit || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.pab"),
    value: constructDisplayPrice(
      insurancesInfo.personalAccidentBenefit || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.adb"),
    value: constructDisplayPrice(
      insurancesInfo.accidentalDeathBenefit +
        insurancesInfo.personalAccidentBenefit || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.accidentalTpd"),
    value: constructDisplayPrice(
      insurancesInfo.accidentalTpdBenefit +
        insurancesInfo.personalAccidentBenefit || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.totalCib"),
    value: constructDisplayPrice(
      insurancesInfo.totalEarlyCIBenefit || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.cib"),
    value: constructDisplayPrice(insurancesInfo.ciBenefit || 0, false),
  },
  {
    label: Locale.get("summaryPolicyDetail.disabilityIncome"),
    value: constructDisplayPrice(
      insurancesInfo.permanentDisabilityMonthlyIncome || 0,
      false
    ),
  },
  {
    label: Locale.get("summaryPolicyDetail.yearlyMedCard"),
    value: insurancesInfo.medicalCardYearlyLimitAmt
      ? constructDisplayPrice(insurancesInfo.medicalCardYearlyLimitAmt, false)
      : "-",
  },
  {
    label: Locale.get("summaryPolicyDetail.lifetimeMedCard"),
    value: insurancesInfo.medicalCardLifetimeLimitAmt
      ? insurancesInfo.medicalCardLifetimeLimitAmt < 0
        ? "Unlimited"
        : constructDisplayPrice(
            insurancesInfo.medicalCardLifetimeLimitAmt,
            false
          )
      : "-",
  },
  {
    label: Locale.get("summaryPolicyDetail.hospitalizationBenefit"),
    value: constructDisplayPrice(insurancesInfo.dailyBenefit || 0, false),
  },
];

const policyCoveragesTableColumns = [
  {
    dataIndex: "label",
    key: "label",
    render: (value, record) => (
      <div>
        <Label>{value}</Label>
        <DescriptionForLabel>{record.desc}</DescriptionForLabel>
      </div>
    ),
  },
  {
    dataIndex: "value",
    key: "value",
    render: (value) => <FinancialValueText>{value}</FinancialValueText>,
  },
  {
    dataIndex: "remarks",
    key: "remarks",
    render: (value) => <ExtraInfoText>{value}</ExtraInfoText>,
  },
];

const Summary = ({ insurancesInfo = {} }) => {
  console.log("insurancesInfo", insurancesInfo);

  const hasMedicalCard = !!insurancesInfo.medicalCardYearlyLimitAmt;
  return (
    <>
      <Title marginBottom="24px">
        {Locale.get("summaryPolicyDetail.pageTitle")}
      </Title>
      <SectionContainer>
        <Row gutter={[16, 16]}>
          <Col span={12} xl={8}>
            <InfoCard title={Locale.get("summaryPolicyDetail.tMonthlyPremium")}>
              <SummaryValueText>
                {insurancesInfo.monthlyPremium
                  ? constructDisplayPrice(insurancesInfo.monthlyPremium, false)
                  : "-"}
              </SummaryValueText>
            </InfoCard>
          </Col>
          <Col span={12} xl={8}>
            <InfoCard title={Locale.get("summaryPolicyDetail.tYearlyPremium")}>
              <SummaryValueText>
                {insurancesInfo.yearlyPremium
                  ? constructDisplayPrice(insurancesInfo.yearlyPremium, false)
                  : "-"}
              </SummaryValueText>
            </InfoCard>
          </Col>
          <Col span={12} xl={8}>
            <InfoCard title={Locale.get("summaryPolicyDetail.ownMedCard")}>
              <SummaryValueText>
                <SecureIcon hasMedicalCard={hasMedicalCard} />
                {hasMedicalCard
                  ? Locale.get("summaryPolicyDetail.yesOwnMedCard")
                  : Locale.get("summaryPolicyDetail.noOwnMedCard")}
              </SummaryValueText>
            </InfoCard>
          </Col>
        </Row>
      </SectionContainer>
      <SectionContainer>
        <Title marginBottom="8px">
          {Locale.get("summaryPolicyDetail.sectionContainerTitle")}
        </Title>
        <Row>
          <Table
            dataSource={constructPolicyCoveragesDataSource(insurancesInfo)}
            columns={policyCoveragesTableColumns}
            pagination={false}
            rowKey={(record) => record.label}
            showHeader={false}
            style={{ width: "100%" }}
          />
        </Row>
      </SectionContainer>
    </>
  );
};

export default Summary;
